export default [
    { type: 0, name: 'Cash' },
    { type: 1, name: 'Credit Card' },
    { type: 9, name: 'E-Wallet' },
    { type: 3, name: 'Voucher' },
    { type: 4, name: 'Others' },
    { type: 12, name: 'Subsidy' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/payment-types.js